<script>
  import AddList from "../form/AddList.svelte";
  import Validators from "../../utils/validators";
  import InputWrapper from "../form/InputWrapper.svelte";
  import PlainInput from "../form/PlainInput.svelte";

  let ratingFields = [
    {
      type: "number",
      name: "rating",
      label: "Rating",
      readonlyValue: true,
      validations: [Validators.required("Rating is required")],
    },
  ];

  let genreFields = [
    {
      type: "list",
      name: "genre",
      label: "Genre",
      readonlyValue: true,
      validations: [Validators.required("Genre is required")],
    },
  ];

  let includeFields = [
    {
      type: "text",
      name: "siteName",
      label: "Site Name",
      readonlyValue: true,
      validations: [Validators.required("Site Name is required")],
    },
    {
      type: "text",
      name: "siteId",
      label: "Site ID",
      readonlyValue: true,
      validations: [Validators.required("Site ID is required")],
    },
  ];

  let excludeFields = [
    {
      type: "text",
      name: "siteName",
      label: "Site Name",
      readonlyValue: true,
      validations: [Validators.required("Site Name is required")],
    },
    {
      type: "text",
      name: "siteId",
      label: "Site ID",
      readonlyValue: true,
      validations: [Validators.required("Site ID is required")],
    },
  ];

  function onAddRating(dataObj) {}
  function onAddGenre(dataObj) {}
  function onAddSiteInclude(dataObj) {}
  function onAddSiteExclude(dataObj) {}

  function onDeleteRating(dataObj) {}
  function onDeleteGenre(dataObj) {}
  function onDeleteSiteInclude(dataObj) {}
  function onDeleteSiteExclude(dataObj) {}
</script>

<div class="flex flex-row w-full gap-2 pb-4">
  <AddList
    name="rating"
    fields={ratingFields}
    onAddRow={onAddRating}
    onDeleteRow={onDeleteRating} />
  <AddList
    name="genre"
    fields={genreFields}
    onAddRow={onAddGenre}
    onDeleteRow={onDeleteGenre} />
</div>

<div class="flex flex-row w-full gap-2 pb-4">
  <div class="w-1/2">
    <h1 class="pb-2 text-xl font-bold">Include</h1>
    <AddList
      name="rating"
      fields={includeFields}
      onAddRow={onAddSiteInclude}
      onDeleteRow={onDeleteSiteInclude} />
  </div>
  <div class="w-1/2">
    <h1 class="pb-2 text-xl font-bold">Exclude</h1>
    <AddList
      name="rating"
      fields={excludeFields}
      onAddRow={onAddSiteExclude}
      onDeleteRow={onDeleteSiteExclude} />
  </div>
</div>
<h1 class="pb-2 text-xl font-bold">Forecasting</h1>
<div class="flex flex-row w-full gap-2 pb-4">
  <div class="w-1/2">
    <InputWrapper label="Uniques">
      <PlainInput name="uniques" value="" />
    </InputWrapper>
  </div>
  <div class="w-1/2">
    <InputWrapper label="Requests">
      <PlainInput name="requests" value="" />
    </InputWrapper>
  </div>
</div>
